import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useRouter } from '../../hooks/useRouter.js';
import { adjustSrc } from '../../utils/adjustSrc.js';
import { style } from '../../utils/style.js';
const sourcesComparator = (a, b) => a?.media && b?.media ? a.media - b.media : 0;
export const ImgAsPicture = JSX(({ className = '', image, imageClassName = '' }) => {
    const router = useRouter();
    return (_jsxs("picture", { className: className, children: [image?.sources?.length
                ? image.sources
                    .filter((_) => _?.src)
                    .sort(sourcesComparator)
                    .map(({ src, format, media }, index) => (_jsx("source", { srcSet: adjustSrc(router)(src), type: formatToMimeType(format), media: media ? `(max-width: ${media}px)` : '', width: image?.size?.width, height: image?.size?.height }, `${index}_${src}`)))
                : null, image?.src
                ? renderImg({ ...image, src: adjustSrc(router)(image.src) }, imageClassName)
                : null] }));
});
const renderImg = (image, imageClassName = '') => (_jsx("img", { src: image.src, className: style('object-contain', imageClassName), alt: image?.alt || image?.title || '', title: image?.title || '', style: {
        width: image?.size?.width ? `${image.size?.width}px` : '100%',
        height: image?.size?.height ? `${image.size?.height}px` : 'auto',
    }, width: image?.size?.width, height: image?.size?.height }));
const formatToMimeType = (format) => format ? `image/${String(format)}` : undefined;
//# sourceMappingURL=ImgAsPicture.js.map